import { Router, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'automation-header',
    templateUrl: './automation-header.component.html',
    styleUrls: ['./automation-header.component.css']
})
export class AutomationHeaderComponent implements OnDestroy, OnInit {


    private routeChanges = null;

    public currentUrl: string = null;

    constructor(private router: Router) { }

    ngOnInit(): void {

        this.currentUrl = this.router.url;

        this.routeChanges = this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe((event: NavigationEnd) => {
                this.currentUrl = event.url;
            });
    }
    ngOnDestroy(): void {

        this.routeChanges.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/automation-header/automation-header.component.ts